module.exports = __webpack_public_path__ + "media/9.a6515303.mp3";